import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-bd4264c6.js';
import './chunk-f647b5cb.js';
import './chunk-0928016a.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-b59d2948.js';
import './chunk-e3b0b539.js';
import './chunk-1bad8473.js';
import './chunk-42f463e6.js';
import './chunk-f8007af2.js';
import './chunk-5d5e2574.js';
import './chunk-01bc3886.js';
import { T as Timepicker } from './chunk-97298426.js';
export { T as BTimepicker } from './chunk-97298426.js';
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Timepicker);
  }
};
use(Plugin);
export default Plugin;